import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      <h1 style={{ fontSize: '28px', marginBottom: '8px' }}>Privacy Policy</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: April 3, 2026</p>

      <p>Premier Motors ("we", "our", "us") operates the AutoBook Pro application. This Privacy Policy explains how we collect, use, and protect information obtained through our services, including data received via Facebook and Instagram Lead Ads.</p>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>1. Information We Collect</h2>
      <p>When you submit a lead form through our Facebook or Instagram advertisements, we may collect:</p>
      <ul>
        <li>Full name</li>
        <li>Phone number</li>
        <li>Email address</li>
        <li>City or location</li>
        <li>Vehicle interest preferences</li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>2. How We Use Your Information</h2>
      <p>We use the collected information to:</p>
      <ul>
        <li>Respond to your vehicle inquiry</li>
        <li>Contact you regarding available vehicles, offers, and pricing</li>
        <li>Schedule test drives and dealership visits</li>
        <li>Improve our products and customer service</li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>3. Data Storage and Security</h2>
      <p>Your data is stored securely on encrypted cloud servers (MongoDB Atlas). We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, or destruction.</p>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>4. Data Sharing</h2>
      <p>We do not sell, trade, or rent your personal information to third parties. Your data is only accessible to authorized Premier Motors sales staff for the purpose of serving your vehicle inquiry.</p>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>5. Data Retention</h2>
      <p>We retain your personal data for as long as necessary to fulfill the purposes for which it was collected, typically for a period of 24 months from the date of collection, unless a longer retention period is required by law.</p>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>6. Your Rights</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Request access to your personal data</li>
        <li>Request correction of inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Withdraw consent at any time</li>
      </ul>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>7. Data Deletion</h2>
      <p>To request deletion of your data, please contact us at <a href="mailto:premieremotollp@gmail.com">premieremotollp@gmail.com</a>. We will process your request within 30 days.</p>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>8. Facebook Data</h2>
      <p>We receive lead information through Facebook Lead Ads integration. This data is used solely for the purpose of responding to vehicle inquiries. We comply with Facebook's Platform Terms and Developer Policies.</p>

      <h2 style={{ fontSize: '20px', marginTop: '30px' }}>9. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>Email: <a href="mailto:premieremotollp@gmail.com">premieremotollp@gmail.com</a></li>
        <li>Business: Premier Motors LLP</li>
      </ul>

      <div style={{ marginTop: '40px', padding: '20px', background: '#f5f5f5', borderRadius: '8px', fontSize: '14px', color: '#666' }}>
        <p>This privacy policy is effective as of April 3, 2026 and will remain in effect except with respect to any changes in its provisions in the future.</p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
